<template>
    <div class="modal-mask" @click.self="close">
        <div class="modal-wrapper">
            <div class="modal-container">
                <div class="modal-header">
                    <slot name="header">

                    </slot>
                </div>

                <div class="modal-body">
                    <slot name="body">

                    </slot>
                </div>

                <div class="modal-footer">
                    <slot name="footer">

                    </slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Modal",
        methods: {
            close() {
                this.$emit('close');
            }
        },
        mounted() {
            this.windowKeydownListener = (event) => {
                if (event.key === 'Escape') {
                    this.close();
                }
            };
            window.addEventListener('keydown', this.windowKeydownListener);
        },
        destroyed() {
            window.removeEventListener('keydown', this.windowKeydownListener);
        },
        data() {
            return {
                windowKeydownListener: null,
            }
        }
    }
</script>

<style scoped lang="scss">
    .modal-mask {
        position: fixed;
        z-index: 9998;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(white, 0.5);
        display: flex;
        align-items: center;
        justify-content: center;
        transition: opacity .3s ease;
    }

    .modal-container {
        padding: 20px 30px;
        background-color: white;
        border-radius: 8px;
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 40px rgba(0, 0, 0, 0.2);
        transition: all .3s ease;
    }

    .modal-header h3 {
        margin-top: 0;
        font-weight: 500;
    }

    .modal-body {
        margin: 20px 0;
    }

    .modal-default-button {
        float: right;
    }
</style>
